import { createFileRoute } from "@tanstack/react-router"

import { RSS_FEED_LINK } from "@/lib/rss-meta"

import { HomeNewPage } from "../-components/home-new/HomeNewPage"
import { homepageCanonicalLink } from "../-components/home/homeRoute"

// The marketing homepage for signed-in visitors, whose `/` is the platform
// Home: the same page as `/`, so it declares `/` as its canonical.
export const Route = createFileRoute("/about/")({
  head: () => ({ links: [homepageCanonicalLink, RSS_FEED_LINK] }),
  component: AboutPage,
})

function AboutPage() {
  return <HomeNewPage />
}
